import { render } from "./PartExceptions.vue?vue&type=template&id=ce0831a2"
import script from "./PartExceptions.vue?vue&type=script&lang=js"
export * from "./PartExceptions.vue?vue&type=script&lang=js"
script.render = render

export default script